

import React from 'react';
import ErrorPage from '../components/error';
import usePageMeta from '../hooks/usePageMeta';
export default function OopsData() {
    usePageMeta('Page Not Found - 404 Error - Navigate Home | Spinnennetz', 'Oops! The page you are looking for does not exist. Return to the Spinnennetz homepage to explore our expert web design, e-commerce solutions, and CRO services.', '/404', {"@context":"https://schema.org","@type":"WebPage","name":"Page Not Found"});
    return (
       <>
        <ErrorPage />
       </>
    )
}
